import { useQuery } from '@tanstack/react-query';

import type { DashboardResponse } from '@dcc-erp/shared';

import { api } from '../api';

// Period is 'YYYYMM'. Pass `undefined` to default to the API's current-month
// behaviour. Gated by `companyId` so the query doesn't fire before the active
// company lookup resolves.
export function useDashboard(companyId: string | undefined, period?: string) {
  const qs = new URLSearchParams();
  if (period) qs.set('period', period);
  const search = qs.toString();
  return useQuery({
    queryKey: ['dashboard', companyId, period],
    queryFn: () =>
      api<DashboardResponse>(`/companies/${companyId}/dashboard${search ? `?${search}` : ''}`),
    enabled: !!companyId,
  });
}
